// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circles_floating {
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    width: 100%;
    height: 100%;
}

@keyframes animate {
    0% {
        opacity: 1;
        border-radius: 0;
        transform: translateY(0) rotate(0deg);
    }

    100% {
        opacity: 0;
        border-radius: 50%;
        transform: translateY(400px) rotate(720deg);

    }
}

.react-datepicker-wrapper{
    width: 112%!important;
}
.react-datepicker-popper{
    z-index: +5!important;
}
#registrationDate{
    width: 100%!important;
}


.circles_floating div {
    position: absolute;
    display: block;
    width: 20px;
    height: 20px;
    background: rgba(255, 255, 255, 0.2);
    top: -150px;
    animation: animate 20s linear infinite;
}

.circles_floating div:nth-child(1) {
    left: 25%;
    width: 80px;
    height: 80px;
    animation-delay: 0s;

}

.circles_floating div:nth-child(2) {
    left: 10%;
    width: 20px;
    height: 20px;
    animation-delay: 2s;
    animation-duration: 12s;


}

.circles_floating div:nth-child(3) {
    left: 70%;
    width: 20px;
    height: 20px;
    animation-delay: 4s;


}

.circles_floating div:nth-child(4) {
    left: 40%;
    width: 60px;
    height: 60px;
    animation-delay: 0s;
    animation-duration: 18s;


}

.circles_floating div:nth-child(5) {
    left: 65%;
    width: 25px;
    height: 25px;
    animation-delay: 0s;



}

.circles_floating div:nth-child(6) {
    left: 75%;
    width: 40px;
    height: 40px;
    animation-delay: 3s;



}

.circles_floating div:nth-child(7) {
    left: 35%;
    width: 80px;
    height: 80px;
    animation-delay: 7s;


}

.circles_floating div:nth-child(8) {
    left: 50%;
    width: 25px;
    height: 25px;
    animation-delay: 15s;
    animation-duration: 45s;


}

.circles_floating div:nth-child(9) {
    left: 20%;
    width: 15px;
    height: 15px;
    animation-delay: 2s;
    animation-duration: 35s;


}

.circles_floating div:nth-child(10) {
    left: 85%;
    width: 80px;
    height: 80px;
    animation-delay: 0s;
    animation-duration: 11s;


}

.circles_floating div:nth-child(11) {
    left: 5%;
    width: 25px;
    height: 25px;
    animation-delay: 0s;
    animation-duration: 11s;


}

.circles_floating div:nth-child(12) {
    left: 0%;
    width: 40px;
    height: 40px;
    animation-delay: 2s;
    animation-duration: 16s;


}

.circles_floating div:nth-child(13) {
    left: 10%;
    width: 20px;
    height: 20px;
    animation-delay: 1s;
    animation-duration: 11s;


}

.circles_floating div:nth-child(11) {
    left: 15%;
    width: 25px;
    height: 25px;
    animation-delay: 7s;
    animation-duration: 11s;


}

.sidebar_overflow {
    overflow: auto !important;
}

.navbar-brand-box {
    background-color: #180f3d !important;
    width: 100%;
    padding: 0 !important;
    object-fit: cover;
    border-bottom: 1px solid #ddd;
}

.errorMessage {
    color: red;
}

.card_dash {
    font-size: 12px !important;
}

.tt {
    text-align: right;
}

.project_filter {
    font-size: 15px;
}

.form_divide hr {
    /* width: 80% !important; */
    margin-bottom: 20px;
}

.max_char {
    font-size: 10px !important;
    color: rgb(139, 138, 135);
    word-break: break-all;
}

.required_field {
    color: rgb(245, 10, 10);
}

.unique_id {
    width: 20% !important;
    margin-left: 5px;
    border: 1px solid rgb(138, 134, 134);
    /* padding: 1px; */
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 3px;

}

.client_active_btn {
    gap: 10px;
}

.client_active_btn .search {

    text-align: right;
    position: absolute;
    justify-content: end;
    align-items: end;
    right: 30px;
    width: 280px !important;
}

.table_client {
    text-align: center !important;
    vertical-align: middle !important;
}

.active_btn {
    color: rgba(var(--vz-success-rgb), var(--vz-bg-opacity)) !important;
    width: 10px;
    height: 10px;
    padding: 0px !important;
}

.inactive_btn {
    color: rgba(var(--vz-warning-rgb), var(--vz-bg-opacity)) !important;
    width: 10px;
    height: 10px;
    padding: 0px !important;
}

.closed_btn {
    color: rgba(var(--vz-danger-rgb), var(--vz-bg-opacity)) !important;
    width: 10px;
    height: 10px;
    padding: 0px !important;
}

.Invoiced_btn {

    background-color: rgb(174, 0, 255);
    color: rgb(174, 0, 255) !important;
    width: 10px;
    height: 10px;
    padding: 0px !important;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
}

.add_qustion {
    width: 100px;
}

.container-fluid .btn {
    box-shadow: 0 1px 5px rgb(0 0 0 / 0.2) !important;
    border: none !important;
}

.card {
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2) !important;
}

.report .form-check {
    display: block;
    min-height: 1.21875rem;
    padding-left: 5.600000000000001em;
    margin-bottom: 0.125rem;
    margin-top: 25px;
}

.report_btn {
    margin-top: 20px;
}

.report_btn .btn {
    width: 100px !important;
}

.page_size_support {
    display: flex;
}

.page_size_support .form-select {
    width: 50%;
    height: 30px;
    margin-left: 5px;

}

.mt-8_rec {
    margin-top: 55px;
}

.fs-8_profile {
    font-size: 34px;
}

.user-name-text-p {
    color: white;
}

.user-name-sub-text-p {
    color: rgb(0, 0, 0) !important;
    font-weight: 600;
}

.country_allowed {
    text-transform: uppercase;
    font-size: 16px !important;
    font-weight: 500;
    color: #303d67;
}

.optionListContainer_div .optionListContainer {
    transform: ease;
    overflow: auto !important;
    z-index: 99;
    height: 90px !important;
}

/* user add css */
.card_user {
    background-color: #f3f3f9 !important;

    
}

.card_user .search {
    width: 40%;
}

.user_sec .user_btn .btn {
    width: 80px;
    border-radius:5px;
    box-shadow: none !important;
    border: 1px solid rgb(8, 8, 8);
}

.user_sec p {
    margin-bottom: 3px;
    margin-top: 0px !important;
}
.module_user p{
    cursor: pointer !important;
}
.module_user p:hover{
    cursor: pointer !important;
    color:#303d67 !important ;
}
.btn-light-module{
    background-color: #ffffff;
    border: none !important;
}
.btn-light-module:hover{
    color:#303d67 !important ;
}
.btn-light-module:active{
    color:#303d67 !important ;
}
.btn-light-module::after{
    color:#303d67 !important ;
}

.user_sec span {
    font-size: 13px;
    color: #4a4e4eb4;
    font-weight: 500;
}
.lower_div{
    background-color: #f3f3f9;
}
.scrool {
    overflow-y: auto !important;
    height: 90vh;
    padding-bottom: 70px;
}

.scrool {
    scrollbar-width: 3px !important;
}

.scrool::-webkit-scrollbar {
    width: 6px !important;    
}
.scrool::-webkit-scrollbar-thumb {
    background: #a5a5a8b9;
}
.sideFirstTab{
    font-size: 40px !important;
}
.bg-primary{
    background-color: #464d64 !important;
}

.bg-grey{
    background-color: rgb(238, 238, 238) !important;
}

/* Table Scrollable */
/* .table-scroll-fixed .table thead th{position:sticky;z-index:99;}
.table-scroll-fixed .table tbody td{position:sticky;z-index:99;}
.table-scroll-fixed thead th:nth-child(1),.table-scroll-fixed thead th:nth-child(2),.table-scroll-fixed thead th:nth-child(3),.table-scroll-fixed thead th:nth-child(4){z-index:999 !important}
.table-scroll-fixed tbody td:nth-child(1),.table-scroll-fixed thead th:nth-child(1){position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;left:0;z-index:999 !important}
.table-scroll-fixed tbody td:nth-child(2),.table-scroll-fixed thead th:nth-child(2){position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;left:50px;z-index:999 !important}
.table-scroll-fixed tbody td:nth-child(3),.table-scroll-fixed thead th:nth-child(3){position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;left:150px;z-index:999 !important}
.table-scroll-fixed tbody td:nth-child(4),.table-scroll-fixed thead th:nth-child(4){position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;left:270px;z-index:999 !important}
.table thead th{white-space:nowrap} */


.customDatePickerWidth .react-datepicker-popper{
   width: 330px;
}



/* Dashboard */
.analyticVal, .analyticLbl{
    display: inline-block;
    width: 100%;
    letter-spacing: -1px;
    text-transform: uppercase;
    font-size: 1rem;
    font-family: "Montserrat", sans-serif !important;
  }
  
  .stylishCard::before{
    content: " ";
    position: absolute;
    left:9px;
    display: inline-block;
    border-radius: 2px;
    height: 75px;
    width: 6px;
    top:24px;
    z-index: 1;
  }
  
  div.stylishCard .analyticVal{
    font-weight: 700;
    font-size: 2rem;
    line-height: 22px;
  }
  
  div.stylishCard .analyticLbl{
    font-weight: 500;
    font-size: 1rem;
    line-height: 30px;
  }
  
  div.stylishCard .analyticST{
    font-weight: normal;
    font-size: 0.7rem;
    line-height: 15px;
    display: inline-block;
  }
  
  div.stylishCard:nth-of-type(1)::before {
    background-color: #F7931E;
  }
  
  div.stylishCard:nth-of-type(1) .analyticVal{
    color:#F7931E;
  }
  
  div.stylishCard:nth-of-type(2)::before {
    background-color: #31A3AA;
  }
  
  div.stylishCard:nth-of-type(2) .analyticVal{
    color:#31A3AA;
  }
  
  div.stylishCard:nth-of-type(3)::before {
    background-color: #4D5FFE;
  }
  
  div.stylishCard:nth-of-type(3) .analyticVal{
    color:#4D5FFE;
  }
  
  div.stylishCard:nth-of-type(4)::before {
    background-color: #3A81D6;
  }
  
  div.stylishCard:nth-of-type(4) .analyticVal{
    color:#3A81D6;
  }
  
    div.stylishCard:nth-of-type(5)::before {
    background-color: #F7931E;
  }
  
  div.stylishCard:nth-of-type(5) .analyticVal{
    color:#F7931E;
  }
  
  div.stylishCard:nth-of-type(6)::before {
    background-color: #31A3AA;
  }
  
  div.stylishCard:nth-of-type(6) .analyticVal{
    color:#31A3AA;
  }
  
  div.stylishCard:nth-of-type(7)::before {
    background-color: #4D5FFE;
  }
  
  div.stylishCard:nth-of-type(7) .analyticVal{
    color:#4D5FFE;
  }
  
  div.stylishCard:nth-of-type(8)::before {
    background-color: #3A81D6;
  }
  
  div.stylishCard:nth-of-type(8) .analyticVal{
    color:#3A81D6;
  }
  
  .stylishCard .card{
    z-index: 0;
  }

.card-border{
    border: 1px solid #beb4b4 !important;
    border-radius: 5px !important;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2) !important;
}
.card-border:hover{
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2) !important;
    transform: scale(1.01);
    transition: all .3s ease-in-out;
}

  .dashboard-container {
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  .dashboard-title {
    color: #2c3e50;
    text-align: center;
    margin-bottom: 30px;
  }
  
  .metrics-section {
    margin-bottom: 40px;
  }
  
  .metrics-section h3 {
    color: #34495e;
    border-bottom: 2px solid #ecf0f1;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  
  .metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(20%, 1fr));
    gap: 20px;
  }
  
  .metrics-grid-col-2 {
    grid-template-columns: repeat(auto-fill, minmax(49%, 1fr));
  }
  .metrics-grid-col-3 {
    grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
  }
  .metrics-grid-col-5 {
    grid-template-columns: repeat(auto-fill, minmax(18%, 1fr));
  }
  
  
  .metric-card, .chart-card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    padding: 15px;
    transition: transform 0.2s;
    margin-bottom: 10px;
  }
  
  .metric-card:hover {
    transform: translateY(-5px);
  }
  
  .metric-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .metric-header h4 {
    margin: 0;
    color: #2c3e50;
    font-size: 1rem;
  }
  
  .metric-tooltip {
    cursor: help;
    font-size: 0.8rem;
    opacity: 0.6;
  }
  
  .metric-value {
    font-size: 1.8rem;
    font-weight: 600;
    color: #3498db;
    margin: 0;
  }
  
  .progress-container {
    background: #ecf0f1;
    border-radius: 10px;
    height: 15px;
    position: relative;
    overflow: hidden;
    /* margin-top: 15px; */
  }
  
  .progress-bar {
    height: 100%;
    background: linear-gradient(90deg, #3498db, #2ecc71);
    border-radius: 10px;
    transition: width 0.5s ease;
  }
  
  .progress-label {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: white;
    font-size: 0.7rem;
    font-weight: bold;
    text-shadow: 0 0 2px rgba(0,0,0,0.5);
  }
  
  .chart-card h4 {
    margin-top: 0;
    color: #2c3e50;
    text-align: center;
  }
  
  .chart-container {
    height: 200px;
    margin-top: 10px;
  }
  
  @media (max-width: 768px) {
    .metrics-grid {
      grid-template-columns: 1fr;
    }
  }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,gBAAgB;QAChB,qCAAqC;IACzC;;IAEA;QACI,UAAU;QACV,kBAAkB;QAClB,2CAA2C;;IAE/C;AACJ;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;;;AAGA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;;AAG3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;;;AAGvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;;AAG3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;;;;AAIvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;;;;AAIvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;;;AAGvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;;;AAG3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;;AAG3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;;AAG3B;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;;AAG3B;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;;AAG3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;;AAG3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;;;AAG3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;;AAEtB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;IACI,mEAAmE;IACnE,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,mEAAmE;IACnE,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,kEAAkE;IAClE,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,kCAAkC;IAClC,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,uCAAuC;AAC3C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iDAAiD;IACjD,uBAAuB;AAC3B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,iCAAiC;IACjC,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;;AAEpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;IACI,oCAAoC;;;AAGxC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,+CAA+C;AACnD;;AAEA,qBAAqB;AACrB;;;;;;;qCAOqC;;;AAGrC;GACG,YAAY;AACf;;;;AAIA,cAAc;AACd;IACI,qBAAqB;IACrB,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,gDAAgD;EAClD;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;IAEE;IACA,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;AAEF;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,kDAAkD;AACtD;AACA;IACI,kDAAkD;IAClD,sBAAsB;IACtB,+BAA+B;AACnC;;EAEE;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,0DAA0D;IAC1D,SAAS;EACX;;EAEA;IACE,0DAA0D;EAC5D;EACA;IACE,0DAA0D;EAC5D;EACA;IACE,0DAA0D;EAC5D;;;EAGA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,oDAAoD;IACpD,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,oCAAoC;EACtC;;EAEA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE;MACE,0BAA0B;IAC5B;EACF","sourcesContent":[".circles_floating {\n    position: absolute;\n    left: 0;\n    top: 0;\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n}\n\n@keyframes animate {\n    0% {\n        opacity: 1;\n        border-radius: 0;\n        transform: translateY(0) rotate(0deg);\n    }\n\n    100% {\n        opacity: 0;\n        border-radius: 50%;\n        transform: translateY(400px) rotate(720deg);\n\n    }\n}\n\n.react-datepicker-wrapper{\n    width: 112%!important;\n}\n.react-datepicker-popper{\n    z-index: +5!important;\n}\n#registrationDate{\n    width: 100%!important;\n}\n\n\n.circles_floating div {\n    position: absolute;\n    display: block;\n    width: 20px;\n    height: 20px;\n    background: rgba(255, 255, 255, 0.2);\n    top: -150px;\n    animation: animate 20s linear infinite;\n}\n\n.circles_floating div:nth-child(1) {\n    left: 25%;\n    width: 80px;\n    height: 80px;\n    animation-delay: 0s;\n\n}\n\n.circles_floating div:nth-child(2) {\n    left: 10%;\n    width: 20px;\n    height: 20px;\n    animation-delay: 2s;\n    animation-duration: 12s;\n\n\n}\n\n.circles_floating div:nth-child(3) {\n    left: 70%;\n    width: 20px;\n    height: 20px;\n    animation-delay: 4s;\n\n\n}\n\n.circles_floating div:nth-child(4) {\n    left: 40%;\n    width: 60px;\n    height: 60px;\n    animation-delay: 0s;\n    animation-duration: 18s;\n\n\n}\n\n.circles_floating div:nth-child(5) {\n    left: 65%;\n    width: 25px;\n    height: 25px;\n    animation-delay: 0s;\n\n\n\n}\n\n.circles_floating div:nth-child(6) {\n    left: 75%;\n    width: 40px;\n    height: 40px;\n    animation-delay: 3s;\n\n\n\n}\n\n.circles_floating div:nth-child(7) {\n    left: 35%;\n    width: 80px;\n    height: 80px;\n    animation-delay: 7s;\n\n\n}\n\n.circles_floating div:nth-child(8) {\n    left: 50%;\n    width: 25px;\n    height: 25px;\n    animation-delay: 15s;\n    animation-duration: 45s;\n\n\n}\n\n.circles_floating div:nth-child(9) {\n    left: 20%;\n    width: 15px;\n    height: 15px;\n    animation-delay: 2s;\n    animation-duration: 35s;\n\n\n}\n\n.circles_floating div:nth-child(10) {\n    left: 85%;\n    width: 80px;\n    height: 80px;\n    animation-delay: 0s;\n    animation-duration: 11s;\n\n\n}\n\n.circles_floating div:nth-child(11) {\n    left: 5%;\n    width: 25px;\n    height: 25px;\n    animation-delay: 0s;\n    animation-duration: 11s;\n\n\n}\n\n.circles_floating div:nth-child(12) {\n    left: 0%;\n    width: 40px;\n    height: 40px;\n    animation-delay: 2s;\n    animation-duration: 16s;\n\n\n}\n\n.circles_floating div:nth-child(13) {\n    left: 10%;\n    width: 20px;\n    height: 20px;\n    animation-delay: 1s;\n    animation-duration: 11s;\n\n\n}\n\n.circles_floating div:nth-child(11) {\n    left: 15%;\n    width: 25px;\n    height: 25px;\n    animation-delay: 7s;\n    animation-duration: 11s;\n\n\n}\n\n.sidebar_overflow {\n    overflow: auto !important;\n}\n\n.navbar-brand-box {\n    background-color: #180f3d !important;\n    width: 100%;\n    padding: 0 !important;\n    object-fit: cover;\n    border-bottom: 1px solid #ddd;\n}\n\n.errorMessage {\n    color: red;\n}\n\n.card_dash {\n    font-size: 12px !important;\n}\n\n.tt {\n    text-align: right;\n}\n\n.project_filter {\n    font-size: 15px;\n}\n\n.form_divide hr {\n    /* width: 80% !important; */\n    margin-bottom: 20px;\n}\n\n.max_char {\n    font-size: 10px !important;\n    color: rgb(139, 138, 135);\n    word-break: break-all;\n}\n\n.required_field {\n    color: rgb(245, 10, 10);\n}\n\n.unique_id {\n    width: 20% !important;\n    margin-left: 5px;\n    border: 1px solid rgb(138, 134, 134);\n    /* padding: 1px; */\n    padding-left: 8px;\n    padding-right: 8px;\n    border-radius: 3px;\n\n}\n\n.client_active_btn {\n    gap: 10px;\n}\n\n.client_active_btn .search {\n\n    text-align: right;\n    position: absolute;\n    justify-content: end;\n    align-items: end;\n    right: 30px;\n    width: 280px !important;\n}\n\n.table_client {\n    text-align: center !important;\n    vertical-align: middle !important;\n}\n\n.active_btn {\n    color: rgba(var(--vz-success-rgb), var(--vz-bg-opacity)) !important;\n    width: 10px;\n    height: 10px;\n    padding: 0px !important;\n}\n\n.inactive_btn {\n    color: rgba(var(--vz-warning-rgb), var(--vz-bg-opacity)) !important;\n    width: 10px;\n    height: 10px;\n    padding: 0px !important;\n}\n\n.closed_btn {\n    color: rgba(var(--vz-danger-rgb), var(--vz-bg-opacity)) !important;\n    width: 10px;\n    height: 10px;\n    padding: 0px !important;\n}\n\n.Invoiced_btn {\n\n    background-color: rgb(174, 0, 255);\n    color: rgb(174, 0, 255) !important;\n    width: 10px;\n    height: 10px;\n    padding: 0px !important;\n    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);\n}\n\n.add_qustion {\n    width: 100px;\n}\n\n.container-fluid .btn {\n    box-shadow: 0 1px 5px rgb(0 0 0 / 0.2) !important;\n    border: none !important;\n}\n\n.card {\n    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2) !important;\n}\n\n.report .form-check {\n    display: block;\n    min-height: 1.21875rem;\n    padding-left: 5.600000000000001em;\n    margin-bottom: 0.125rem;\n    margin-top: 25px;\n}\n\n.report_btn {\n    margin-top: 20px;\n}\n\n.report_btn .btn {\n    width: 100px !important;\n}\n\n.page_size_support {\n    display: flex;\n}\n\n.page_size_support .form-select {\n    width: 50%;\n    height: 30px;\n    margin-left: 5px;\n\n}\n\n.mt-8_rec {\n    margin-top: 55px;\n}\n\n.fs-8_profile {\n    font-size: 34px;\n}\n\n.user-name-text-p {\n    color: white;\n}\n\n.user-name-sub-text-p {\n    color: rgb(0, 0, 0) !important;\n    font-weight: 600;\n}\n\n.country_allowed {\n    text-transform: uppercase;\n    font-size: 16px !important;\n    font-weight: 500;\n    color: #303d67;\n}\n\n.optionListContainer_div .optionListContainer {\n    transform: ease;\n    overflow: auto !important;\n    z-index: 99;\n    height: 90px !important;\n}\n\n/* user add css */\n.card_user {\n    background-color: #f3f3f9 !important;\n\n    \n}\n\n.card_user .search {\n    width: 40%;\n}\n\n.user_sec .user_btn .btn {\n    width: 80px;\n    border-radius:5px;\n    box-shadow: none !important;\n    border: 1px solid rgb(8, 8, 8);\n}\n\n.user_sec p {\n    margin-bottom: 3px;\n    margin-top: 0px !important;\n}\n.module_user p{\n    cursor: pointer !important;\n}\n.module_user p:hover{\n    cursor: pointer !important;\n    color:#303d67 !important ;\n}\n.btn-light-module{\n    background-color: #ffffff;\n    border: none !important;\n}\n.btn-light-module:hover{\n    color:#303d67 !important ;\n}\n.btn-light-module:active{\n    color:#303d67 !important ;\n}\n.btn-light-module::after{\n    color:#303d67 !important ;\n}\n\n.user_sec span {\n    font-size: 13px;\n    color: #4a4e4eb4;\n    font-weight: 500;\n}\n.lower_div{\n    background-color: #f3f3f9;\n}\n.scrool {\n    overflow-y: auto !important;\n    height: 90vh;\n    padding-bottom: 70px;\n}\n\n.scrool {\n    scrollbar-width: 3px !important;\n}\n\n.scrool::-webkit-scrollbar {\n    width: 6px !important;    \n}\n.scrool::-webkit-scrollbar-thumb {\n    background: #a5a5a8b9;\n}\n.sideFirstTab{\n    font-size: 40px !important;\n}\n.bg-primary{\n    background-color: #464d64 !important;\n}\n\n.bg-grey{\n    background-color: rgb(238, 238, 238) !important;\n}\n\n/* Table Scrollable */\n/* .table-scroll-fixed .table thead th{position:sticky;z-index:99;}\n.table-scroll-fixed .table tbody td{position:sticky;z-index:99;}\n.table-scroll-fixed thead th:nth-child(1),.table-scroll-fixed thead th:nth-child(2),.table-scroll-fixed thead th:nth-child(3),.table-scroll-fixed thead th:nth-child(4){z-index:999 !important}\n.table-scroll-fixed tbody td:nth-child(1),.table-scroll-fixed thead th:nth-child(1){position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;left:0;z-index:999 !important}\n.table-scroll-fixed tbody td:nth-child(2),.table-scroll-fixed thead th:nth-child(2){position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;left:50px;z-index:999 !important}\n.table-scroll-fixed tbody td:nth-child(3),.table-scroll-fixed thead th:nth-child(3){position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;left:150px;z-index:999 !important}\n.table-scroll-fixed tbody td:nth-child(4),.table-scroll-fixed thead th:nth-child(4){position:-webkit-sticky;position:-moz-sticky;position:-ms-sticky;position:-o-sticky;position:sticky;left:270px;z-index:999 !important}\n.table thead th{white-space:nowrap} */\n\n\n.customDatePickerWidth .react-datepicker-popper{\n   width: 330px;\n}\n\n\n\n/* Dashboard */\n.analyticVal, .analyticLbl{\n    display: inline-block;\n    width: 100%;\n    letter-spacing: -1px;\n    text-transform: uppercase;\n    font-size: 1rem;\n    font-family: \"Montserrat\", sans-serif !important;\n  }\n  \n  .stylishCard::before{\n    content: \" \";\n    position: absolute;\n    left:9px;\n    display: inline-block;\n    border-radius: 2px;\n    height: 75px;\n    width: 6px;\n    top:24px;\n    z-index: 1;\n  }\n  \n  div.stylishCard .analyticVal{\n    font-weight: 700;\n    font-size: 2rem;\n    line-height: 22px;\n  }\n  \n  div.stylishCard .analyticLbl{\n    font-weight: 500;\n    font-size: 1rem;\n    line-height: 30px;\n  }\n  \n  div.stylishCard .analyticST{\n    font-weight: normal;\n    font-size: 0.7rem;\n    line-height: 15px;\n    display: inline-block;\n  }\n  \n  div.stylishCard:nth-of-type(1)::before {\n    background-color: #F7931E;\n  }\n  \n  div.stylishCard:nth-of-type(1) .analyticVal{\n    color:#F7931E;\n  }\n  \n  div.stylishCard:nth-of-type(2)::before {\n    background-color: #31A3AA;\n  }\n  \n  div.stylishCard:nth-of-type(2) .analyticVal{\n    color:#31A3AA;\n  }\n  \n  div.stylishCard:nth-of-type(3)::before {\n    background-color: #4D5FFE;\n  }\n  \n  div.stylishCard:nth-of-type(3) .analyticVal{\n    color:#4D5FFE;\n  }\n  \n  div.stylishCard:nth-of-type(4)::before {\n    background-color: #3A81D6;\n  }\n  \n  div.stylishCard:nth-of-type(4) .analyticVal{\n    color:#3A81D6;\n  }\n  \n    div.stylishCard:nth-of-type(5)::before {\n    background-color: #F7931E;\n  }\n  \n  div.stylishCard:nth-of-type(5) .analyticVal{\n    color:#F7931E;\n  }\n  \n  div.stylishCard:nth-of-type(6)::before {\n    background-color: #31A3AA;\n  }\n  \n  div.stylishCard:nth-of-type(6) .analyticVal{\n    color:#31A3AA;\n  }\n  \n  div.stylishCard:nth-of-type(7)::before {\n    background-color: #4D5FFE;\n  }\n  \n  div.stylishCard:nth-of-type(7) .analyticVal{\n    color:#4D5FFE;\n  }\n  \n  div.stylishCard:nth-of-type(8)::before {\n    background-color: #3A81D6;\n  }\n  \n  div.stylishCard:nth-of-type(8) .analyticVal{\n    color:#3A81D6;\n  }\n  \n  .stylishCard .card{\n    z-index: 0;\n  }\n\n.card-border{\n    border: 1px solid #beb4b4 !important;\n    border-radius: 5px !important;\n    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2) !important;\n}\n.card-border:hover{\n    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2) !important;\n    transform: scale(1.01);\n    transition: all .3s ease-in-out;\n}\n\n  .dashboard-container {\n    max-width: 1366px;\n    margin: 0 auto;\n    padding: 0 20px;\n  }\n  \n  .dashboard-title {\n    color: #2c3e50;\n    text-align: center;\n    margin-bottom: 30px;\n  }\n  \n  .metrics-section {\n    margin-bottom: 40px;\n  }\n  \n  .metrics-section h3 {\n    color: #34495e;\n    border-bottom: 2px solid #ecf0f1;\n    padding-bottom: 10px;\n    margin-bottom: 20px;\n  }\n  \n  .metrics-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(20%, 1fr));\n    gap: 20px;\n  }\n  \n  .metrics-grid-col-2 {\n    grid-template-columns: repeat(auto-fill, minmax(49%, 1fr));\n  }\n  .metrics-grid-col-3 {\n    grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));\n  }\n  .metrics-grid-col-5 {\n    grid-template-columns: repeat(auto-fill, minmax(18%, 1fr));\n  }\n  \n  \n  .metric-card, .chart-card {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n    padding: 15px;\n    transition: transform 0.2s;\n    margin-bottom: 10px;\n  }\n  \n  .metric-card:hover {\n    transform: translateY(-5px);\n  }\n  \n  .metric-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n  \n  .metric-header h4 {\n    margin: 0;\n    color: #2c3e50;\n    font-size: 1rem;\n  }\n  \n  .metric-tooltip {\n    cursor: help;\n    font-size: 0.8rem;\n    opacity: 0.6;\n  }\n  \n  .metric-value {\n    font-size: 1.8rem;\n    font-weight: 600;\n    color: #3498db;\n    margin: 0;\n  }\n  \n  .progress-container {\n    background: #ecf0f1;\n    border-radius: 10px;\n    height: 15px;\n    position: relative;\n    overflow: hidden;\n    /* margin-top: 15px; */\n  }\n  \n  .progress-bar {\n    height: 100%;\n    background: linear-gradient(90deg, #3498db, #2ecc71);\n    border-radius: 10px;\n    transition: width 0.5s ease;\n  }\n  \n  .progress-label {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: white;\n    font-size: 0.7rem;\n    font-weight: bold;\n    text-shadow: 0 0 2px rgba(0,0,0,0.5);\n  }\n  \n  .chart-card h4 {\n    margin-top: 0;\n    color: #2c3e50;\n    text-align: center;\n  }\n  \n  .chart-container {\n    height: 200px;\n    margin-top: 10px;\n  }\n  \n  @media (max-width: 768px) {\n    .metrics-grid {\n      grid-template-columns: 1fr;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
